<ng-template #itemTemplate let-item="item">
  <div class="language-selection-panel-language-name">
    {{ 'Settings::Call.Language.' + item.name | abpLocalization }}
  </div>
</ng-template>

<ng-template #selectionTemplate let-item="item">
  {{ 'Settings::Call.Language.' + item.name | abpLocalization }}
</ng-template>

<ng-container [formGroup]="editorForm">
  <ca-selector
    #languageSelector
    formControlName="editor"
    [url]="languageSelectorOptions.url"
    [filters]="languageSelectorOptions.filters"
    [itemTemplate]="itemTemplate"
    [selectionTemplate]="selectionTemplate"
    [queryOperator]="languageSelectorOptions.queryOperator"
    [queryField]="languageSelectorOptions.queryField"
    [multiple]="'true'"
    [emptyText]="languageSelectorOptions.emptyText"
    [showSelections]="languageSelectorOptions.showSelections"
    [showClearSelections]="languageSelectorOptions.showClearSelections"
    [showClearSelectionLink]="languageSelectorOptions.showClearSelectionLink"
    [selectorPosition]="languageSelectorOptions.selectorPosition"
    [styles]="{ width: '100%', 'border-width': '0px' }"
    [pageSize]="languageSelectorOptions.pageSize"
    [currentPage]="languageSelectorOptions.currentPage"
    [hideSearch]="true"></ca-selector>
</ng-container>
